(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  const initializeFaq = (container) => {
    if (!container || container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const search = container.querySelector('.ss-faq__search');
    const filters = Array.from(container.querySelectorAll('[data-filter]'));
    const items = Array.from(container.querySelectorAll('[data-faq-item]'));
    const empty = container.querySelector('[data-faq-empty]');
    const status = container.querySelector('[data-faq-status]');
    let activeCategory = 'all';

    const updateResults = () => {
      const query = search.value.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const matchesCategory = activeCategory === 'all' || item.dataset.category === activeCategory;
        const matchesSearch = !query || item.dataset.search.includes(query);
        const isVisible = matchesCategory && matchesSearch;
        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      empty.hidden = visibleCount !== 0;
      const label = visibleCount === 1 ? container.dataset.questionSingular : container.dataset.questionPlural;
      status.textContent = `${visibleCount} ${label} ${container.dataset.foundText}`;
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.filter;
        filters.forEach((button) => {
          const isActive = button === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        updateResults();
      });
    });

    search.addEventListener('input', updateResults);
  };

  document.querySelectorAll('.ss-faq[data-section-id]').forEach(initializeFaq);
  document.addEventListener('shopify:section:load', (event) => {
    initializeFaq(event.target.querySelector('.ss-faq[data-section-id]'));
  });

  } catch(e) { console.error(e); }
})();
})();
